/* CARVER — First-drop reserve intercept.
   Replaces checkout with the reserve modal, records intent events, and shows
   the success state after the customer-form round trip. */
(function () {
  'use strict';

  var dlg = document.getElementById('cv-reserve');
  var qs = new URLSearchParams(location.search);
  var icFired = false;

  function fireInitiateCheckout() {
    if (icFired || !dlg) return;
    icFired = true;
    var value = parseFloat(dlg.getAttribute('data-cart-total')) || 0;
    var numItems = parseInt(dlg.getAttribute('data-cart-count'), 10) || 0;
    try {
      if (window.fbq) fbq('track', 'InitiateCheckout', { value: value, currency: 'USD', num_items: numItems });
    } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('carver_reserve_open', { cartTotal: value, itemCount: numItems });
      }
    } catch (e) {}
  }

  function fireLead() {
    try {
      if (sessionStorage.getItem('cvReserveLead')) return;
      sessionStorage.setItem('cvReserveLead', '1');
    } catch (e) {}
    try {
      if (window.fbq) fbq('track', 'Lead', { content_name: 'first-drop-reserve' });
    } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('carver_reserve_complete', {});
      }
    } catch (e) {}
  }

  function setView(name) {
    if (!dlg) return;
    dlg.querySelectorAll('[data-reserve-view]').forEach(function (v) {
      v.hidden = v.getAttribute('data-reserve-view') !== name;
    });
  }

  function openModal(success) {
    if (!dlg) return;
    setView(success ? 'success' : 'form');
    if (!dlg.open) dlg.showModal();
    if (!success) {
      fireInitiateCheckout();
      var email = dlg.querySelector('input[type="email"]');
      if (email) email.focus();
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-reserve-close]')) {
      if (dlg && dlg.open) dlg.close();
      return;
    }
    var trigger = e.target.closest('[data-reserve-open], button[name="checkout"], a[href*="/checkout"]');
    if (trigger) {
      e.preventDefault();
      openModal(false);
    }
  }, true);

  /* Safety net: no form on this site may submit to checkout. */
  document.addEventListener('submit', function (e) {
    var action = e.target.getAttribute('action') || '';
    if (action.indexOf('/checkout') > -1) {
      e.preventDefault();
      openModal(false);
    }
  }, true);

  /* Click on the backdrop closes the dialog. */
  if (dlg) {
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) dlg.close();
    });
  }

  /* Success state after the customer-form round trip. */
  if (qs.get('reserved') === 'ok' || (qs.get('customer_posted') === 'true' && location.pathname.indexOf('/cart') > -1)) {
    openModal(true);
    fireLead();
  }
})();
